import Footer from "../components/lib/Footer";
import CallToAction from "../components/landing-page/home/CTA";
import HeroSection from "../components/landing-page/home/HeroSection";
import Marquee from "../components/landing-page/home/Marquee";
import Slider from "../components/landing-page/home/Slider";
import Testimonial from "../components/landing-page/home/Testimonial";
import Navbar from "../components/lib/Navbar";
import Loader from "../components/lib/Loader";

const Home = () => {
  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <Navbar />
      </div>
      <div>
        <HeroSection />
      </div>
      <div>
        <div className="lg:border-y border-border py-6">
          <h1 className="text-center font-semibold text-primaryBlack text-[24px] lg:text-3xl">
            We are trusted by
          </h1>
          <Marquee />
        </div>
      </div>
      <div>
        <div className="my-16">
          <h1 className="text-center font-semibold text-primaryBlack text-[24px] lg:text-3xl">
            We can help you with
          </h1>
          <Slider />
        </div>
      </div>
      <div>
        <CallToAction />
      </div>
      <div>
        <div className="mt-16 lg:mt-28">
          <div className="px-6 lg:px-16 pb-5 border-b border-border">
            <h1 className="font-semibold text-primaryBlack text-[32px] lg:text-[40px] lg:max-w-[400px]">
              What our customers are saying
            </h1>
          </div>
          <div className="mb-10">
            <Testimonial />
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
